export default __webpack_public_path__ + "static/media/HARTFORD.d395d792.jpg";